// extracted by mini-css-extract-plugin
module.exports = {"side_bar":"styles_side_bar__1xXHn","current_info":"styles_current_info__hvC8N","info_list":"styles_info_list__sXheO","phone":"styles_phone__TLNe5"};